// eslint-disable-next-line
import {
  RouteView,
  PageView
} from '@/layouts'
import {
  bxAnaalyse
} from '@/core/icons'

export const orderRouter = [{
  path: '/order',
  redirect: '/order/search/orderList',
  component: RouteView,
  name:"orderGroup",
  meta: {
    title: '订单',
    keepAlive: false,
    icon: 'file-search'
  },
  children: [{
    path: '/order/orderSearch',
    redirect: '/order/search/orderList',
    component: RouteView,
    name:"orderSearchGroup",
    meta: {
      title: '订单查询',
      keepAlive: true
    },
    children: [{
      path: '/order/search/orderList',
      name: 'OrderList',
      component: () => import('@/views/order/search/OrderList'),
      meta: {
        title: '订单列表',
        keepAlive: true
      }
    },
      {
        hidden: true, //不显示在菜单上
        path: '/order/search/orderDetails',
        name: 'OrderDetails',
        component: () => import('@/views/order/search/OrderDetails'),
        meta: {
          title: '订单详情',
          keepAlive: true,
          hideInMenu: true
        }
      },
      {
        hidden: true, //不显示在菜单上 销售订单，为供应商时
        path: '/order/search/orderDetails',
        name: 'OSalesOrderDetails',
        component: () => import('@/views/order/search/OrderReconstruction/SalesOrderDetails'),
        meta: {
          title: '订单详情（销售订单）',
          keepAlive: true,
          hideInMenu: true
        }
      },
      {
        hidden: true, //不显示在菜单上  采购订单,为分销商时
        path: 'order/search/OrderReconstruction',
        name: 'PurchaseOrderDetails',
        component: () => import('@/views/order/search/OrderReconstruction/PurchaseOrderDetails'),
        meta: {
          title: '订单详情（采购订单）',
          keepAlive: true,
          hideInMenu: true
        }
      },
      //本期暂无
      {
        path: '/order/search/cloudOrders',
        name: 'CloudOrders',
        component: () => import('@/views/order/search/CloudOrders'),
        meta: {
          title: '云仓订单',
          keepAlive: true
        }
      }
    ]
  },
    {
      path: '/order/tools',
      redirect: '/order/tool/consignment',
      component: RouteView,
      name:"orderToolsGroup",
      meta: {
        title: '订单工具',
        keepAlive: true
      },
      children: [{
        path: '/order/tool/consignment',
        name: 'Consignment',
        component: () => import('@/views/order/tool/Consignment'),
        meta: {
          title: '批量发货',
          keepAlive: true
        }
      },
        {
          path: '/order/tool/evaluate',
          name: 'Evaluate',
          component: () => import('@/views/order/tool/Evaluate'),
          meta: {
            title: '评价管理',
            keepAlive: true
          }
        },
        {
          path: '/order/tool/consolidation',
          name: 'ConsolidationServices',
          component: () => import('@/views/order/tool/ConsolidationServices'),
          meta: {
            title: '配送服务',
            keepAlive: true
          }
        },
        {
          hidden: true, //不显示在菜单上
          path: '/order/tool/addCarriageTemplate',
          name: 'AddCarriageTemplate',
          component: () => import('@/views/order/tool/AddCarriageTemplate'),
          meta: {
            title: '添加运费模板',
            keepAlive: false,
            hideInMenu: true
          }
        },
        {
          path: '/order/tool/template',
          name: 'InvoiceTemplate',
          component: () => import('@/views/order/tool/InvoiceTemplate'),
          meta: {
            title: '发票模版',
            keepAlive: true
          }
        },
        {
          hidden: true, //不显示在菜单上
          path: '/order/tool/add',
          name: 'AddInvoiceTemplate',
          component: () => import('@/views/order/tool/AddInvoiceTemplate'),
          meta: {
            title: '添加发票模板',
            keepAlive: false,
            hideInMenu: true
          }
        }
      ]
    },
    {
      path: '/order/refund',
      redirect: '/order/refund/refundList',
      component: RouteView,
      name:"refundGroup",
      meta: {
        title: '售后管理',
        keepAlive: true
      },
      children: [{
        path: '/order/refund/refundList',
        name: 'RefundList',
        component: () => import('@/views/order/refund/RefundList'),
        meta: {
          title: '退款/售后',
          keepAlive: true
        }
      },
        {
          hidden: true, //不显示在菜单上
          path: '/order/refund/RefundDetail',
          name: 'RefundDetail',
          component: () => import('@/views/order/refund/RefundDetail'),
          meta: {
            title: '售后详情',
            keepAlive: true,
            hideInMenu: true
          }
        }
      ]
    }
  ]
}]